// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMBadge.tsx — PropelMapper status pill / count badge.
// Semantic surfaces (success/info/warning/error/neutral/primary) from --pm-*
// tokens. Optional leading dot; uppercase + count styles.

const PMBADGE_CSS = `
.pmbadge{box-sizing:border-box;display:inline-flex;align-items:center;gap:5px;font:var(--pm-label-m);font-weight:700;border-radius:var(--pm-radius-pill,999px);padding:4px 11px;letter-spacing:.02em;line-height:1;white-space:nowrap}
.pmbadge-dot{width:7px;height:7px;border-radius:50%;background:currentColor;flex:0 0 7px}
.pmbadge--success{background:var(--pm-surface-success);color:var(--pm-success-dark)}
.pmbadge--info{background:var(--pm-surface-info);color:var(--pm-info-dark)}
.pmbadge--warning{background:var(--pm-surface-warning);color:var(--pm-warning-dark)}
.pmbadge--error{background:var(--pm-surface-error);color:var(--pm-error-dark)}
.pmbadge--neutral{background:var(--pm-surface-variant);color:var(--pm-fg-2)}
.pmbadge--primary{background:var(--pm-primary-surface);color:var(--pm-primary-dark)}
.pmbadge--upper{text-transform:uppercase;letter-spacing:.04em;font-size:11px}
.pmbadge--count{font:var(--pm-pill);padding:2px 8px}
`;
function pmbadgeEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmbadge-css")) return;
  const s = document.createElement("style"); s.id = "pmbadge-css"; s.textContent = PMBADGE_CSS;
  document.head.appendChild(s);
}
export function PMBadge({ variant = "neutral", dot = false, uppercase = false, count = false, className = "", style = {}, children, ...rest }) {
  pmbadgeEnsureCSS();
  const cls = "pmbadge pmbadge--" + variant + (uppercase ? " pmbadge--upper" : "") + (count ? " pmbadge--count" : "") + (className ? " " + className : "");
  return (
    <span className={cls} style={style} {...rest}>
      {dot ? <span className="pmbadge-dot" /> : null}
      {children}
    </span>
  );
}
